import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Alertstripe from "nav-frontend-alertstriper";
import { FnrInput } from "./../../";
import FnrInputExample from "./../../sample/_fnr-input.example.js";
export const _frontmatter = {
  "ingress": "FnrInput er et vanlig nummerisk <a href=\"/components/input\">Input</a>-felt som har innebygget funksjonalitet for validering av fødselsnummer."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}></ol></nav>

    <p>{`Komponenten bruker `}<a parentName="p" {...{
        "href": "https://github.com/navikt/fnrvalidator"
      }}>{`@navikt/fnrvalidator`}</a>{` internt for å validere brukers input.`}</p>
    <Example mdxType="Example">
  <FnrInputExample mdxType="FnrInputExample" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<form onSubmit={(e) => handleSubmit(e)}>
  <FnrInput
    label="Fødselsnummer (11 siffer)"
    bredde="S"
    value={value}
    onChange={(e) => handleChange(e)}
    onValidate={(val) => setValid(val)}
    feil={submit && !valid ? "Ugyldig fødselsnummer" : undefined}
  />
</form>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      